__turbopack_context__.v({
  "checkIcon": "ParagraphMetricsChecklistImage-module__NJYEzq__checkIcon",
  "desc": "ParagraphMetricsChecklistImage-module__NJYEzq__desc",
  "eyebrow": "ParagraphMetricsChecklistImage-module__NJYEzq__eyebrow",
  "feature": "ParagraphMetricsChecklistImage-module__NJYEzq__feature",
  "features": "ParagraphMetricsChecklistImage-module__NJYEzq__features",
  "image": "ParagraphMetricsChecklistImage-module__NJYEzq__image",
  "imageCaption": "ParagraphMetricsChecklistImage-module__NJYEzq__imageCaption",
  "left": "ParagraphMetricsChecklistImage-module__NJYEzq__left",
  "metricCard": "ParagraphMetricsChecklistImage-module__NJYEzq__metricCard",
  "metricLabel": "ParagraphMetricsChecklistImage-module__NJYEzq__metricLabel",
  "metricValue": "ParagraphMetricsChecklistImage-module__NJYEzq__metricValue",
  "metrics": "ParagraphMetricsChecklistImage-module__NJYEzq__metrics",
  "right": "ParagraphMetricsChecklistImage-module__NJYEzq__right",
  "section": "ParagraphMetricsChecklistImage-module__NJYEzq__section",
  "title": "ParagraphMetricsChecklistImage-module__NJYEzq__title",
});
